import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
const adres = "https://api.pth-hokej.pl";
const FormWrapper = styled.section`
  width: 70%;
  margin: 2rem auto;
  background: #fefefe;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
`;

const Button = styled.button`
  background: #5e0078;
  color: white;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  &:hover {
    background: #420058;
  }
`;

const ListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
`;

const EventCard = styled.article`
  flex: 0 0 240px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const EventsForm = () => {
  const [events, setEvents] = useState([]);
  const [formData, setFormData] = useState({ nazwa: "", data: "", adres: "" });
  const [editId, setEditId] = useState(null);

  const fetchEvents = async () => {
    const res = await axios.get(`${adres}/api/scheduledevents`);
    setEvents(res.data);
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`${adres}/api/scheduledevents${editId}`, formData);
      } else {
        await axios.post(`${adres}/api/scheduledevents`, formData);
      }
      setFormData({ nazwa: "", data: "", adres: "" });
      setEditId(null);
      fetchEvents();
    } catch (err) {
      console.error("Błąd zapisu:", err);
    }
  };

  const handleEdit = ev => {
    setFormData({ nazwa: ev.nazwa, data: ev.data, adres: ev.adres });
    setEditId(ev._id);
  };

  const handleDelete = async id => {
    const confirmed = window.confirm("Czy na pewno chcesz usunąć to wydarzenie?");
    if (!confirmed) return;
    await axios.delete(`${adres}/api/scheduledevents/${id}`);
    fetchEvents();
  };

  return (
    <FormWrapper>
      <h2>{editId ? "Edytuj wydarzenie" : "Dodaj wydarzenie"}</h2>
      <form className="formMainbox" onSubmit={handleSubmit}>
        <Input
          type="text"
          name="nazwa"
          placeholder="Nazwa wydarzenia"
          value={formData.nazwa}
          onChange={handleChange}
          required
        />
        <Input
          type="date"
          name="data"
          value={formData.data}
          onChange={handleChange}
          required
        />
        <Input
          type="text"
          name="adres"
          placeholder="Adres wydarzenia"
          value={formData.adres}
          onChange={handleChange}
          required
        />
        <Button type="submit">{editId ? "Zapisz zmiany" : "Dodaj wydarzenie"}</Button>
      </form>

      <ListWrapper>
        {events.map(ev => (
          <EventCard key={ev._id}>
            <div>
              <h4>{ev.nazwa}</h4>
              <p>{new Date(ev.data).toLocaleDateString()}</p>
              <p><small>{ev.adres}</small></p>
            </div>
            <div style={{ marginTop: "1rem" }}>
              <Button onClick={() => handleEdit(ev)} style={{ marginRight: "0.5rem" }}>
                Edytuj
              </Button>
              <Button onClick={() => handleDelete(ev._id)} style={{ background: "#aa0000" }}>
                Usuń
              </Button>
            </div>
          </EventCard>
        ))}
      </ListWrapper>
    </FormWrapper>
  );
};
